import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

// Strategy pages
const VisionPage = lazy(() =>
  import('../pages/strategy/VisionPage').then((m) => ({ default: m.VisionPage }))
)
const ObjectivesPage = lazy(() =>
  import('../pages/strategy/ObjectivesPage').then((m) => ({ default: m.ObjectivesPage }))
)
const BusinessCasePage = lazy(() =>
  import('../pages/strategy/BusinessCasePage').then((m) => ({ default: m.BusinessCasePage }))
)
const ROICalculatorPage = lazy(() =>
  import('../pages/strategy/ROICalculatorPage').then((m) => ({ default: m.ROICalculatorPage }))
)
const RoadmapPage = lazy(() =>
  import('../pages/strategy/RoadmapPage').then((m) => ({ default: m.RoadmapPage }))
)
const PrioritizationPage = lazy(() =>
  import('../pages/strategy/PrioritizationPage').then((m) => ({ default: m.PrioritizationPage }))
)

export const strategyRoutes: RouteObject[] = [
  { path: '/strategy/vision', element: <VisionPage /> },
  { path: '/strategy/objectives', element: <ObjectivesPage /> },
  { path: '/strategy/business-case', element: <BusinessCasePage /> },
  { path: '/strategy/roi-calculator', element: <ROICalculatorPage /> },
  { path: '/strategy/roadmap', element: <RoadmapPage /> },
  { path: '/strategy/prioritization', element: <PrioritizationPage /> },
]
